import { Link } from 'react-router';
import { styled } from '@mui/material/styles';

const NotFoundContainer = styled('div')`
  margin-left: 8px;
  width: 100%;
`;

const NotFound = () => (
  <NotFoundContainer>
    <h1>404 - Not Found.</h1>
    <h2>You tried to visit a page that does not exist.</h2>
    <Link to='/'>Go back to project explorer.</Link>
  </NotFoundContainer>
);

export default NotFound;
